import React from "react";
import { Link } from "react-router-dom";

export default function Error() {
  return (
    <div style={{ textAlign: "center", padding: "3rem" }}>
      <h1>404 — Page not found</h1>
      <p>Oops! The page you’re looking for doesn’t exist.</p>
      <Link to="/">Go back home</Link>
    </div>
  );
}
